import { Link } from "react-router-dom";
import { useEnquiry } from "@/components/site/EnquiryContext";
import { company } from "@/content/site";

export const Footer = () => {
  const { openEnquiry } = useEnquiry();
  const a = company.address;
  return (
    <footer className="bg-[#0B1E31] text-[#D6E0E9]" data-testid="site-footer" style={{ paddingBottom: "env(safe-area-inset-bottom)" }}>
      <div className="container-x grid gap-12 py-16 md:grid-cols-12 md:py-20">
        <div className="md:col-span-4">
          <img src="/img/logo-white.png" alt="ALUMICOM Architectural Aluminum Products" width="1801" height="357" loading="lazy" className="h-auto w-[220px]" />
          <p className="mt-6 max-w-xs text-sm leading-relaxed">Design, manufacture and glazing of aluminum systems for residential, commercial and high-rise projects since {company.established}.</p>
        </div>
        <div className="md:col-span-3">
          <h2 className="text-sm font-semibold uppercase tracking-[0.16em] text-white">Visit</h2>
          <address className="mt-4 text-sm not-italic leading-relaxed">{company.legalName}<br />{a.street}<br />{a.city}, {a.region} {a.postal}<br />{a.country}</address>
          <ul className="mt-4 grid gap-1 text-sm">
            {company.hours.map(([d, h]) => <li key={d}><span className="text-white">{d}:</span> {h}</li>)}
          </ul>
        </div>
        <div className="md:col-span-3">
          <h2 className="text-sm font-semibold uppercase tracking-[0.16em] text-white">Contact</h2>
          <ul className="mt-4 grid gap-1.5 text-sm">
            <li>Toll free: <a className="footer-link" href="tel:+18557618554" data-testid="footer-tollfree">{company.tollFree}</a></li>
            <li>Tel: <a className="footer-link" href="tel:+19057618554" data-testid="footer-phone">{company.tel}</a></li>
            <li>Fax: {company.fax}</li>
            <li>Email: <a className="footer-link" href={`mailto:${company.email}`} data-testid="footer-email">{company.email}</a></li>
            <li><a className="footer-link" href={company.instagram} target="_blank" rel="noopener noreferrer">Instagram @alumicom_inc</a></li>
          </ul>
          <button type="button" className="btn-glass btn-on-dark mt-6" onClick={() => openEnquiry("Footer — Send an enquiry")} data-testid="footer-contact-btn">Send an enquiry</button>
        </div>
        <nav aria-label="Footer" className="md:col-span-2">
          <h2 className="text-sm font-semibold uppercase tracking-[0.16em] text-white">Explore</h2>
          <ul className="mt-4 grid gap-1.5 text-sm">
            <li><Link className="footer-link" to="/">Home</Link></li>
            <li><Link className="footer-link" to="/residential">Residential</Link></li>
            <li><Link className="footer-link" to="/commercial">Commercial</Link></li>
            <li><Link className="footer-link" to="/#projects">Projects</Link></li>
            <li><Link className="footer-link" to="/commercial#documents">Technical documents</Link></li>
          </ul>
        </nav>
      </div>
      <div className="border-t border-white/10">
        <div className="container-x flex flex-wrap justify-between gap-2 pb-24 pt-6 text-xs text-[#B9C7D4] md:pr-48 md:pb-8">
          <p>© {new Date().getFullYear()} {company.legalName} All rights reserved.</p>
          <p>Vaughan, Ontario, Canada</p>
        </div>
      </div>
    </footer>
  );
};
